import { createError } from './create-error';

export const TopicSyncError = createError(
  'TopicSyncError',
  'Failed to synchronize topics.',
  {
    HANDSHAKE_FAILED: 'Connection unavailable. Handshake not finalized.',
    CONNECTION_UNAVAILABLE: "Connection wasn't opened",
    REQUEST_FAILED: 'Failed to request topics',
  } as const
);
